module.exports = __webpack_public_path__ + "static/media/NS_Logo_WonB.2ea3378e.svg";